import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { url } from "./settings";
import * as serviceWorker from "./serviceWorker";

// Apollo
import { ApolloProvider, InMemoryCache, ApolloClient } from "@apollo/client";

const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: `${url}/graphql/`,
  resolvers: {},
  credentials: "include",
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <App client={client} />
  </ApolloProvider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
